import {MeetingInfo} from "../models/general/DocumentInfo.model";

/* tslint:disable */

export const MEETINGS: MeetingInfo[] = [
  // {
  //   name: "IPIB Board Meeting xx/xx/23",
  //   link: "view/meetings~2023_xx_xx_board~info",
  //   useHost: true,
  //   description: null,
  //   date: "xx/xx/23",
  //   youtubeLink: "xx",
  //   hasMinutes: true,
  //   hasAgenda: true,
  //   ipibLink: "xx",
  //   isUpcoming: false,
  // },
  {
    name: "IPIB Board Meeting 01/19/23",
    link: "view/meetings~2023_01_19_board~info",
    useHost: true,
    description: null,
    date: "01/19/23",
    youtubeLink: "OOLvkI1Nv8I",
    hasMinutes: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-electronic-0",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 12/15/22",
    link: "view/meetings~2022_12_15_board~info",
    useHost: true,
    description: null,
    date: "12/15/22",
    youtubeLink: "F5tT0pW3zvs&t=1s",
    hasMinutes: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-electronic",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 11/17/22",
    link: "view/meetings~2022_11_17_board~info",
    useHost: true,
    description: null,
    date: "11/17/22",
    youtubeLink: "lNU4ZhRqOSs",
    hasMinutes: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-66",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 10/20/22",
    link: "view/meetings~2022_10_20_board~info",
    useHost: true,
    description: null,
    date: "10/20/22",
    youtubeLink: "s7KhavuQKvk",
    hasMinutes: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-65",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 09/15/22",
    link: "view/meetings~2022_09_15_board~info",
    useHost: true,
    description: null,
    date: "09/15/22",
    youtubeLink: "vLA1gktjNBg",
    hasMinutes: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-64",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 08/18/22",
    link: "view/meetings~2022_08_18_board~info",
    useHost: true,
    description: null,
    date: "08/18/22",
    youtubeLink: "zt-_HViYaa8",
    hasMinutes: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-63",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 07/21/22",
    link: "view/meetings~2022_07_21_board~info",
    useHost: true,
    description: null,
    date: "07/21/22",
    youtubeLink: "KMwVqvHvJBg",
    hasMinutes: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-62",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 07/11/22: Rules Public Hearing",
    link: "view/meetings~2022_07_11_board~info",
    useHost: true,
    description: null,
    date: "07/11/22",
    youtubeLink: "OtKlJjHPWFQ",
    hasMinutes: false,
    areMinutesExempt: true,
    hasAgenda: true,
    ipibLink: "ipib-public-hearing-rules",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 05/19/22",
    link: "view/meetings~2022_05_19_board~info",
    useHost: true,
    description: null,
    date: "05/19/22",
    youtubeLink: "T_WQmd8rt8E",
    hasMinutes: true,
    hasMinutesPDF: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-61",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 04/21/22",
    link: "view/meetings~2022_04_21_board~info",
    useHost: true,
    description: null,
    date: "04/21/22",
    youtubeLink: "vrhqa8SZZqI",
    hasAgendaPDF: true,
    hasMinutes: true,
    hasMinutesPDF: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-60",
    isUpcoming: false,
  },
  {
    name: "IPIB Board Meeting 03/17/22",
    link: "view/meetings~2022_03_17_board~info",
    useHost: true,
    description: null,
    date: "03/17/22",
    youtubeLink: "-NqrqlIT68k",
    hasMinutes: true,
    hasMinutesPDF: true,
    hasAgenda: true,
    ipibLink: "ipib-board-meeting-59",
  },
  {
    name: "IPIB Board Meeting 02/17/22",
    link: "view/meetings~2022_02_17_board~info",
    useHost: true,
    description: null,
    date: "02/17/22",
    hasAgendaPDF: true,
    hasMinutes: true,
    hasAgenda: true,
    youtubeLink: "jj1Fpmwqw1c",
    ipibLink: "ipib-board-meeting-electronic-meeting-14",
  },
  {
    name: "IPIB Board Meeting 01/20/22",
    link: "view/meetings~2022_01_20_board~info",
    useHost: true,
    description: null,
    date: "01/20/22",
    hasAgendaPDF: true,
    hasMinutes: true,
    hasAgenda: true,
    youtubeLink: "w9Fx5yeRvPQ",
    ipibLink: "ipib-board-meeting-58",
  },
];
